import type { IDataFeedProvider } from './IDataFeedProvider';
import type { ProviderConnection,KiteCredentials,Instrument, ApiResponse, HistoricalCandleBar, Interval } from '@ocktra/shared-types';;
import { apiClient } from '../api/apiClient';
import { connectToKite } from '../providers/kite/utils';
import { Quote } from '@ocktra/shared-types';
import { IDataFeedProviderDisconnectResponse } from './IDataFeedProvider';
import type { BaseCandleBar } from '@ocktra/shared-types';


export class ZerodhaDataFeedProvider implements IDataFeedProvider {
    private credentials: KiteCredentials={
        apiKey: '',
        apiSecret: '',

    };
    private connection: ProviderConnection | null = null;
    private connected: boolean = false;
    private ws: WebSocket | null = null;
    private instruments: Map<string, Instrument> = new Map();
    private quoteCallbacks: Map<string, Set<(quote: Quote) => void>> = new Map();


    constructor() {

    }

    public updateCredentials(credentials:Record<string,string>): void {
        this.credentials = {
            apiKey: credentials.apiKey || '',
            apiSecret: credentials.apiSecret || ''
        };
    }

    async updateConnectionDetails(connection: ProviderConnection): Promise<void> {
        this.connection = connection;
    }

    private getConnectionId(): string | null {
        return this.connection ? this.connection.id : null;
    }

    async connect(credentials:Record<string,string>): Promise<ProviderConnection> {

        if(!credentials.apiKey || !credentials.apiSecret ){
            throw new Error('Missing required credentials: apiKey, apiSecret, accessToken');
        }

        this.credentials.apiKey=credentials.apiKey;

        const kiteCredentials:KiteCredentials={
            apiKey: credentials.apiKey,
            apiSecret: credentials.apiSecret,
        };

        try{
            
            const providerType="data_provider";
            const response=await connectToKite(kiteCredentials,providerType)
            
            this.credentials=kiteCredentials;
            this.connection=response;

            await this.initiateOAuthFlow();
            
            return response
            
        }catch(err){
            console.error('[ZerodhaDataFeed] Connection error:', err);
            throw err;
        }
    }    

    async reconnect(connectionId:string): Promise<void> {
        if(!connectionId){
            throw new Error('Missing connection ID for reconnection');
        }

        await this.initiateOAuthFlow();
    }



    /**
     * Initiates OAuth flow by opening Kite Connect login popup
     * @returns Promise that resolves when OAuth flow is complete
     */
    private initiateOAuthFlow(): Promise<void> {
        return new Promise((resolve, reject) => {
            const apiKey = this.credentials.apiKey;
            console.log(resolve)

            // Construct Kite Connect login URL
            const loginUrl = `https://kite.zerodha.com/connect/login?api_key=${apiKey}&v=3`;

            // Open popup window
            const width = 600;
            const height = 700;
            const left = window.screenX + (window.outerWidth - width) / 2;
            const top = window.screenY + (window.outerHeight - height) / 2;

            const popup = window.open(
                loginUrl,
                'Zerodha Login',
                `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes`
            );

            if (!popup) {
                reject(new Error('Popup blocked. Please allow popups for this site.'));
                return;
            }

            // Poll for redirect with request_token
            const pollTimer = setInterval(() => {
                try {
                    // Check if popup is closed
                    if (popup.closed) {
                        clearInterval(pollTimer);
                        reject(new Error('OAuth flow cancelled by user'));
                        return;
                    }


                } catch (e) {
                    // Cross-origin error is expected while on Zerodha domain
                    // Continue polling

                }
            }, 500);

            // Timeout after 5 minutes
            setTimeout(() => {
                clearInterval(pollTimer);
                if (!popup.closed) {
                    popup.close();
                }
                reject(new Error('OAuth flow timed out'));
            }, 5 * 60 * 1000);
        });
    }

    async disconnect(): Promise<IDataFeedProviderDisconnectResponse> {
        if (this.ws) {
        }

        this.connected = false;
        this.instruments.clear();
        this.quoteCallbacks.clear();
        
        const response=await apiClient.post('/provider/disconnect',{
            providerName: 'kite',
            providerType:"data_provider"
        });

        if(response.success){
            console.log('[ZerodhaDataFeed] Disconnected successfully from backend');
            return {
                success: true,
                message: 'Disconnected successfully'
            }
        }else{
            console.warn('[ZerodhaDataFeed] Disconnection from backend failed:', response.message);
            return {
                success: false,
                message: 'Disconnection failed: ' + response.message
            }

        }
    }

    isConnected(): boolean {
        return this.connected;
    }

    async getProfile(): Promise<any> {
        const connectionId=this.getConnectionId();
        if(!connectionId){
            throw new Error('Not connected to Zerodha Kite API');
        }


        const response = await apiClient.post<{
            status: string;
            data: AnalyserNode
        }>('/user/profile',{
            connectionId: connectionId
        });

        if(response.status !== 'success'){
        }

    }

    async getQuote(symbol: string): Promise<Quote> {
        console.log('getQuote called for symbol:', symbol);
        // if (!this.connected) {
        //     throw new Error('Not connected to Zerodha Kite API');
        // }

        // try {
        //     const instrument = await this.findInstrumentBySymbol(symbol);
        //     if (!instrument) {
        //         throw new Error(`Instrument not found: ${symbol}`);
        //     }

        //     const response = await this.apiRequest<KiteQuoteResponse>(`/quote?i=${encodeURIComponent(exchangeSymbol)}`);

        //     const data = response.data[exchangeSymbol];
        //     if (!data) {
        //         throw new Error(`No quote data available for ${symbol}`);
        //     }

        //     return {
        //         symbol: instrument.symbol,
        //         price: data.last_price,
        //         change: data.net_change,
        //         changePercent: (data.net_change / data.ohlc.close) * 100,
        //         volume: data.volume,
        //         high: data.ohlc.high,
        //         low: data.ohlc.low,
        //         open: data.ohlc.open,
        //         previousClose: data.ohlc.close,
        //         timestamp: new Date(data.timestamp).getTime()
        //     };
        // } catch (error) {
        //     console.error('[ZerodhaDataFeed] Error fetching quote:', error);
        //     throw error;
        // }
        throw new Error('Method not implemented.');
    }

    async getQuotes(symbols: string[]): Promise<Quote[]> {
        console.log('getQuotes called for symbols:', symbols);
        // if (!this.connected) {
        //     throw new Error('Not connected to Zerodha Kite API');
        // }

        // try {
        //     // Get instruments for all symbols
        //     const instruments = await Promise.all(
        //         symbols.map(symbol => this.findInstrumentBySymbol(symbol))
        //     );

        //     const validInstruments = instruments.filter((inst): inst is Instrument => inst !== null);
        //     if (validInstruments.length === 0) {
        //         return [];
        //     }

        //     // Build query string with exchange:tradingsymbol format
        //     const queryParams = validInstruments
        //         .map(inst => `i=${encodeURIComponent(`${inst.exchange}:${inst.tradingSymbol}`)}`).join('&');

        //     const response = await this.apiRequest<KiteQuoteResponse>(`/quote?${queryParams}`);

        //     return validInstruments.map(instrument => {
        //         const key = `${instrument.exchange}:${instrument.tradingSymbol}`;
        //         const data = response.data[key];

        //         if (!data) {
        //             return {
        //                 symbol: instrument.symbol,
        //                 price: 0,
        //                 change: 0,
        //                 changePercent: 0,
        //                 volume: 0,
        //                 high: 0,
        //                 low: 0,
        //                 open: 0,
        //                 previousClose: 0,
        //                 timestamp: Date.now()
        //             };
        //         }

        //         return {
        //             symbol: instrument.symbol,
        //             price: data.last_price,
        //             change: data.net_change,
        //             changePercent: (data.net_change / data.ohlc.close) * 100,
        //             volume: data.volume,
        //             high: data.ohlc.high,
        //             low: data.ohlc.low,
        //             open: data.ohlc.open,
        //             previousClose: data.ohlc.close,
        //             timestamp: new Date(data.timestamp).getTime()
        //         };
        //     });
        // } catch (error) {
        //     console.error('[ZerodhaDataFeed] Error fetching quotes:', error);
        //     throw error;
        // }
        return [];
    }

    subscribeQuote(symbol: string, callback: (quote: Quote) => void): () => void {
        console.log('subscribeQuote called for symbol:', symbol,callback);
        // if (!this.quoteCallbacks.has(symbol)) {
        //     this.quoteCallbacks.set(symbol, new Set());
        // }
        // this.quoteCallbacks.get(symbol)!.add(callback);

        // // Subscribe via WebSocket if connected
        // if (this.wsConnected) {
        //     this.findInstrumentBySymbol(symbol).then(instrument => {
        //         if (instrument?.instrumentToken && typeof instrument.instrumentToken === 'number') {
        //             this.wsSubscribeByToken([instrument.instrumentToken]);
        //         }
        //     });
        // }

        // return () => {
        //     const callbacks = this.quoteCallbacks.get(symbol);
        //     if (callbacks) {
        //         callbacks.delete(callback);
        //         if (callbacks.size === 0) {
        //             this.quoteCallbacks.delete(symbol);

        //             // Unsubscribe from WebSocket if no more callbacks
        //             this.findInstrumentBySymbol(symbol).then(instrument => {
        //                 if (instrument?.instrumentToken && typeof instrument.instrumentToken === 'number') {
        //                     this.wsUnsubscribeByToken([instrument.instrumentToken]);
        //                 }
        //             });
        //         }
        //     }
        // };
        throw new Error('Method not implemented.');
    }

    async getHistoricalData(symbol:string,interval:Interval,from:number,to:number): Promise<BaseCandleBar[]> {

        const connectionId=this.getConnectionId();
        if(!connectionId){
            throw new Error('Not connected to Zerodha Kite API');
        }

        try {
        

            const response=await apiClient.post<ApiResponse<{
                historicalData:HistoricalCandleBar[]
            }>>('/provider/historical',{
                    symbol,
                    interval,
                    from,
                    to,
                    connId: connectionId
                });

            if(!response.success || !response.data){
                throw new Error('Error fetching historical data: ' + response);
            }

            const {historicalData}=response.data
            const data: BaseCandleBar[] = [];
            historicalData.forEach(candle => { 
                data.push({
                    open: candle.open,
                    close: candle.close,
                    high: candle.high,
                    low: candle.low,
                    volume: candle.volume || 0,
                    time: new Date(candle.date).getTime()/1000
                })
            });

            return data
                
        } catch (error) {
            console.error('[ZerodhaDataFeed] Error fetching historical data:', error);
            throw error;
        }
    }
}
